module.exports = __webpack_public_path__ + "assets/img/ic-bonus.841d276d.svg";